import { render, staticRenderFns } from "./Ajustes.vue?vue&type=template&id=323dc89a&scoped=true"
import script from "./Ajustes.vue?vue&type=script&lang=js"
export * from "./Ajustes.vue?vue&type=script&lang=js"
import style0 from "./Ajustes.vue?vue&type=style&index=0&id=323dc89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323dc89a",
  null
  
)

export default component.exports